interface ShippingSizeDataClass {
    id: number;
    width: number;
    height: number;
}
var _ssd: ShippingSizeDataClass[] = [];
_ssd.push({id: 1, width: 8.5, height: 11.0});
_ssd.push({id: 2, width: 10.0, height: 12.0});
_ssd.push({id: 3, width: 11.0, height: 14.0});
_ssd.push({id: 4, width: 12.0, height: 16.0});
_ssd.push({id: 5, width: 14.0, height: 18.0});
_ssd.push({id: 6, width: 16.0, height: 20.0});
_ssd.push({id: 7, width: 18.0, height: 24.0});
export const ShippingSizeData: ShippingSizeDataClass[] = _ssd;

interface DocumentSizeTierClass {
    DocumentSizeTierID: number;
    Width: number;
    Height: number;
    IsMax: boolean;
    UsePlexiglass: boolean;
}
var _dstc: DocumentSizeTierClass[] = [];
_dstc.push({DocumentSizeTierID: 1, Width: 8.0, Height: 10.0, IsMax: false, UsePlexiglass: false});
_dstc.push({DocumentSizeTierID: 2, Width: 8.5, Height: 11.7, IsMax: false, UsePlexiglass: false});
_dstc.push({DocumentSizeTierID: 3, Width: 10.0, Height: 12.0, IsMax: false, UsePlexiglass: false});
_dstc.push({DocumentSizeTierID: 4, Width: 11.0, Height: 14.0, IsMax: false, UsePlexiglass: false});
_dstc.push({DocumentSizeTierID: 5, Width: 12.0, Height: 16.0, IsMax: false, UsePlexiglass: false});
_dstc.push({DocumentSizeTierID: 8, Width: 14.0, Height: 18.0, IsMax: false, UsePlexiglass: true});
_dstc.push({DocumentSizeTierID: 9, Width: 16.0, Height: 20.0, IsMax: false, UsePlexiglass: true});
_dstc.push({DocumentSizeTierID: 10, Width: 18.0, Height: 22.0, IsMax: false, UsePlexiglass: true});
_dstc.push({DocumentSizeTierID: 11, Width: 20.0, Height: 24.0, IsMax: false, UsePlexiglass: true});
_dstc.push({DocumentSizeTierID: 12, Width: 200.0, Height: 200.0, IsMax: true, UsePlexiglass: true});
_dstc.push({DocumentSizeTierID: 13, Width: 8.0, Height: 9.3, IsMax: false, UsePlexiglass: false});
_dstc.push({DocumentSizeTierID: 14, Width: 5.0, Height: 7.0, IsMax: false, UsePlexiglass: false});
export const DocumentSizeTierData: DocumentSizeTierClass[] = _dstc;
